<template>
    <div class="wrap opti_wrap" :class="{pd110: btnFixed}" id="app">
        <div class="loading-wrap" :style="togg()">
            <div class="loading-box"><img src="https://resource.0168.net.cn/activity-mall/images/loading-img.gif" style="width: 120px; border-radius: 10px;padding-left: 0px;">
                <div style="width: 100%; color: white; padding: 10px 6px;">稍等片刻~</div>
            </div>
        </div>

        <div class="flow_top">
            <div class="top-activity-rules__d" style="background: rgb(255, 112, 0); color: white;" @click="jumpToActivity">活动规则</div>
            <img src="https://resource.0168.net.cn/activity-mall/h5/theme_aqy/banner.jpg" alt="" class="main-top">
            <img src="https://resource.0168.net.cn/activity-mall/h5/theme_aqy/ling.png" alt="" style="width: 20%; position: absolute; top: 0.4rem; left: 0.1rem; animation: 2s ease 0s infinite normal none running zy; transform-origin: 50% bottom;">
        </div>

        <div class="scroll-container">
            <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="item in getInfo" :key="item">
                            <div  class="scroll-item" > {{ item }} </div>
                        </div>
                    </div>
        </div>

        <div class="flow_top flow_input_bg">
            <img :src="mode == 1 || mode == 2 ? inputBgImgSrc1_2 : inputBgImgSrc" alt="" class="main-top">

            <div class="formElement1" :class="{flow_select3 : mode == 3, flow_select : mode == 0, flow_select1 : mode == 1 || mode == 2}" >
                <div class="formBox van-cell-group van-hairline--top-bottom" v-if="mode == 0 || mode ==3">
                    <div class="form phone van-cell van-cell--required van-field">
                        <div class="van-cell__value van-cell__value--alone van-field__value">
                            <div class="van-field__body"><input type="tel" v-model="phonenum" id="inputPhone" placeholder="请输入你的手机号" class="van-field__control"></div>
                        </div>
                    </div>
                </div>

                <div class="formBox formBoxPhone van-cell-group van-hairline--top-bottom" v-if="mode == 3">
                    <div class="form phone van-cell van-cell--required van-field">
                        <div class="van-cell__value van-cell__value--alone van-field__value">
                            <div class="van-field__body">
                                <input type="number" inputmode="decimal" v-model="captcha" placeholder="请输入验证码" class="van-field__control">
                                <div class="van-field__button" v-if="timesCount === 0" @click="bindOpen">
                                    <div size="small" type="primary" style="color: rgb(240, 169, 25); font-size: 0.28rem; height: 1.1rem; line-height: 1.1rem;">
                                        <span style="margin-right: 0.2rem; position: relative; top: -0.02rem;">|</span>获取验证码
                                    </div>
                                </div>
                                <div class="van-field__button" v-else>
                                    <div size="small" type="primary" style="color: rgb(240, 169, 25); font-size: 0.28rem; height: 1.1rem; line-height: 1.1rem;">
                                        <span style="margin-right: 0.2rem; position: relative; top: -0.02rem;">|</span>{{timesCount}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="cap" v-if="mode == 1 || mode == 2">
                    <iframe width="100%" scrolling="no" id="frame" name="frame" :src="capUrl" frameborder="0"></iframe>
                </div>
                <div class="btn_box" v-if="mode == 0 || mode ==3">
                    <img src="https://resource.0168.net.cn/activity-mall/h5/theme_aqy/get_btn.png" class="btn_img" :class="{fixed: btnFixed}" @click="bindOpen">
                </div>

                <div class="agree" v-if="mode == 0 || mode ==3">
                    <img src="https://resource.0168.net.cn/activity-mall/common/unchecked_yellow.png" v-if="!checked" @click="checked = !checked">
                    <img src="https://resource.0168.net.cn/activity-mall/common/checked_yellow.png" v-else @click="checked = !checked">
                    <span>
                        <span @click="checked = !checked">我已详细阅读并同意</span>
                        <a href="https://store.0168.net.cn/activity-mall/h5/indexaqy_activity.html"><u>活动规则</u></a>、
                        <a href="https://store.0168.net.cn/activity-mall/privacy/content.html"><u>用户隐私协议</u></a>
                        及相关条款
                    </span>
                </div>
                <div class="product-info" v-if="mode == 0 || mode ==3">
                    <p>开通联合会员，领热门会员+话费</p>
                    <p>业务资费：6元起/月</p>
                    <p>客服电话：<a href="tel:4008008663">4008008663</a></p>
                </div>

            </div>
        </div>
        <div class="ftxs_main" v-if="isGdt">
            <img src="https://resource.0168.net.cn/activity-mall/h5/common/bottom.jpg" class="benefit-bg">
        </div>

        <div class="product-info1" v-if="channelid == '1020526004'">
            <p>公司名称：湖南锋芒传媒有限公司</p>
            <p>地址：长沙市雨花区井湾子街道井莲路397号紫铭大厦2610</p>
            <p>联系电话：<a href="tel:13024568854">13024568854</a></p>
        </div

        <qs-msg-box :isloading="isLoading" :msg="msg" :flag="flag"></qs-msg-box>
        <qs-quit-box :showQuitModal="showQuitModal" :channelId="channelid" :phone="phonenum" :tuiaId="advertId" v-on:closeQuitModal="closeQuitModal"></qs-quit-box>
        <page-close-mask :showMask="pageClose"></page-close-mask>

        <iframe width="100%" scrolling="no"  :src="productUrl" style="display: none"></iframe>
    </div>
</template>

<script>
import 'common/css/reset.css';
import 'common/css/swiper.min.css'
import msgBox from "components/MessageBox.vue"
import quitBox from "components/TuiaQuitBox.vue"
import fullMask from "components/FullMask.vue"
import llgsdk from 'common/js/liuliangguo.js';
import closedChannels from 'common/data/closeChannel.json'

import Swiper from 'common/js/swiper.min.js'
import $ from 'jquery'
import baseMethod from 'common/js/baseMethod.js'

export default {
    name: 'product',
    components: {
        "qs-msg-box" : msgBox,
        "qs-quit-box": quitBox,
        "page-close-mask": fullMask

    },
    created(){
        var _this = this;

        _this.channelid = baseMethod.getQueryString("channelid") ? baseMethod.getQueryString("channelid") : '18000000';
        _this.isGdt = baseMethod.isGuangdiantongChannel(_this.channelid);
        _this.unionSite = baseMethod.getUnionSite() ? baseMethod.getUnionSite() : '';;
        _this.advertId = baseMethod.getAdvertId();
        _this.productId = baseMethod.getQueryString("product") ? baseMethod.getQueryString("product") : "XWPBM1Q74" ;

        _this.group = baseMethod.getQueryString("group");
        _this.topImgSrc = "https://resource.0168.net.cn/activity-mall/woread/theme1/top_all.jpg";
        _this.quitToUrl = _this.quitToUrl + "?channelid=" + _this.channelid;

        var pwd = baseMethod.getQueryString("pwd");
        if(pwd && pwd == '****aqear'){
            _this.pageClose = false;
        }

        _this.init();
        _this.getPageUrl();

        window.addEventListener('scroll', this.bindScroll);
        if(closedChannels.close.indexOf(_this.channelid) > -1){
            _this.pageClose = true;
        }
         if(_this.channelid != '18000000' && _this.group != 'XY7HESWY1' && closedChannels.review.indexOf(_this.channelid) <= -1 && !baseMethod.isKAChannel(_this.channelid)){
            let state = {
                title: 'title',
                url: '#'
            }
            window.history.pushState(state, 'title', '#')
            let _this = this
            window.addEventListener('popstate', function(e) {
                _this.showQuitModal = true;
                return false
            }, false);
        }
        var phone = baseMethod.getQueryString("phone");
        var phone1 = baseMethod.getQueryString("bcx_phone");
        if(phone || phone1){
          console.log(phone)
          _this.phonenum = phone ? Base64.decode(phone) :phone1
          _this.checked = true;
          setTimeout(function(){
            _this.bindOpen();
          },500)
        }
    },
    data(){
        return {
            topImgSrc: "",
            inputBgImgSrc: "https://resource.0168.net.cn/activity-mall/h5/theme_aqy/input_bg.jpg",
            inputBgImgSrc1_2:  "https://resource.0168.net.cn/activity-mall/h5/theme_aqy/input_bg1.jpg",
            productName: "",


            visibleNotes: true,
            showQuestion: false,
            showPrivacy: true,
            isDis: false,
            isLoading: false,
            msg: '加载中。。。',
            flag: false,
            phonenum: '',
            channelid: '',
            unionSite: '',
            wokey: '',
            advertId: '',
            productId: '',
            group: '',
            trace: '',
            capUrl:'',
            productUrl: '',
            btnFixed: false,
            showQuitModal: false,
            showRecomBox: false,
            recomProduct: "",
            recomUrl: "",

            quitActivityImgSrc: "https://resource.0168.net.cn/activity-mall/baoxian/banner.gif",
            quitBtnImgSrc:"https://resource.0168.net.cn/activity-mall/5Gn/image/5Gn_get_btn.png",
            quitToUrl:"https://u.mbldbg.com/2af4",
            getInfo: [
                '130 **** 9493 已领取会员权益',
                '155 **** 9512 已领取会员权益',
                '130 **** 2181 已领取会员权益',
                '132 **** 3279 已领取会员权益',
                '132 **** 6917 已领取会员权益',
                '155 **** 5511 已领取会员权益',
                '131 **** 7510 已领取会员权益',
                '131 **** 1495 已领取会员权益',
                '130 **** 1043 已领取会员权益',
                '186 **** 1905 已领取会员权益',
                '155 **** 2309 已领取会员权益',
            ],
            checked: false,
            timesCount: 0,
            captcha: '',
            mode: "0",
            data: {},
            mifaChannel: ['450001', '410001'],
            youzhengChannel: ['680001','680002'],
            juhuangChannel: ['480001'],
            orderId: "",
            isLock: false,
            attempCount: 0,
            pageClose: false,
            isGdt: false
        };
    },
    watch:{
        phonenum(now, old) {
            if (now.length == 11 && old.length == 10 && !baseMethod.isGuangdiantongChannel(this.channelid)) {
                var _this = this;
                _this.checked = true;
                _this.bindOpen();
            }
        }
    },
    mounted(){
        this.initSwiper();
    },
    methods:{
        initSwiper() {
                new Swiper('.scroll-container', {
                    lazy: {
                        loadPrevNext: true,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    loop: true,
                    speed: 1500,
                    loopAdditionalSlides: 1,
                    autoplayStopOnLast: true,
                    autoplay: {
                        disableOnInteraction: false,
                        delay: 0,
                    },
                    delay: 0,
                    effect: "coverflow",
                    slidesPerView: 1.4,
                    centeredSlides: true,
                    coverflowEffect: {
                        slideShadows: false,
                        rotate: 0,
                        stretch: 0,
                        modifier: 2
                    },
                    observer: true, //修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true, //修改swiper的父元素时，自动初始化swiper
                });
            },
        bindScroll() {
            this.scrollHeight = document.documentElement.scrollTop || document.body.scrollTop
            if (this.scrollHeight > 600) {
                this.btnFixed = true
            } else {
                this.btnFixed = false
            }
        },
        togg() {
           return this.isDis === false ? 'display:none' : 'display:block'
        },
        bindOpen() {
            let _this = this;

            if(_this.btnFixed){
                document.getElementById('inputPhone').focus();
                return;
            }

            if(!_this.checked){
                    _this.showMsg("请勾选同意隐私协议及相关条款");
                    return;
            }
              if(_this.isLock && _this.attempCount > 2){
                    _this.showMsg("请10秒后再试！");
                    return;
                }

                _this.isLock = true;
                _this.attempCount++;

                setTimeout(function(){
                    _this.isLock = false;
                },10000)


            if(_this.timesCount != 0 ){
                 if (baseMethod.isEmpty(_this.captcha)) {
                    _this.showMsg("验证码不能为空！");
                    return;
                }
                _this.subCode();
                return;
            }

            if (!baseMethod.isMobile(_this.phonenum)) {
                _this.showMsg("请输入正确的手机号码");
                return;
            }

            let params = {
                product: _this.productId,
                channel_id: _this.channelid,
                tel: _this.phonenum,
                advert_id: _this.advertId,
                union_site: _this.unionSite,
                wokey: _this.wokey,
                request: window.location.href,
                preelection: _this.productUrl,
                device: JSON.stringify(_d),
                source_url: location.href
            }
            _this.isDis = true;
            $.ajax({
                url: 'https://api.0168.net.cn/qiaosi/product/v2/payment',
                type: 'post',
                dataType: 'json',
                data: params,
                success: function(res) {
                    _this.isDis = false;
                    if (res.code.startsWith("01")) {
                        //展开
                        _this.mode="1";
                        _this.capUrl = res.data.pay_url;
                        $("#cap").slideDown(500);
                    }else if(res.code.startsWith("02")){
                        //发码
                         _this.mode="3";
                        _this.orderId = res.order_id;
                        _this.timesCount = 120;
                         const time = setInterval(() => {
                            if (_this.timesCount == 0) {
                                clearInterval(time)
                            } else {
                                _this.timesCount --;
                            }
                        }, 1000)
                    } else if (res.code.startsWith("03")){
                            _this.isDis = false;
                            _this.mode = res.data.mode;
                            _this.timesCount = 120;
                            _this.data = res.data;

                             const time = setInterval(() => {
                                if (_this.timesCount == 0) {
                                    clearInterval(time)
                                } else {
                                    _this.timesCount --;
                                }
                            }, 1000)
                       } else if (res.code.startsWith("04")){
                           //跳转
                            window.location.href = res.data.pay_url;
                            //保存订单号  created查询订单状态
                            localStorage.setItem('hy_order_id', res.order_id);
                            localStorage.setItem('hy_order_expire', new Date().getTime() + 3*60*1000);
                       } else if(res.code.startsWith("05")){
                            console.log(res.code)
                            _this.isDis = false;
                            _this.showRecomBox = true;
                            _this.recomProduct = res.productName;
                            _this.recomUrl = res.productUrl;
                       } else if (res.code.startsWith("07")) {
                            window.location.href = res.data.pay_url;
                       } else {
                        _this.isDis = false;
                        _this.showMsg(res.msg);
                        if(_this.channelid != '18000000' && _this.group != 'XY7HESWY1' && closedChannels.review.indexOf(_this.channelid) <= -1){
                            if(baseMethod.isTuiaChannel(_this.channelid)){
                               _this.showMsg("正在为您准备专属优惠...");
                                window.parent.location.href="https://engine.6wn9tvuhh6.cn/index/activity?appKey=2L46pGwwDGwUA6grDBuTSS2d6ek8&adslotId=462689&phone=" + Base64.encode(_this.phonenum);
                            } else {
                                llgsdk.llg(_this.phonenum, res.msg);
                            }
                        }
                    }
                },
                error: function(res) {
                    _this.isDis = false;
                    _this.showMsg("系统繁忙，请稍后再试！");
                }
            })
        },
        subCode(){
            let _this = this;

            if(_this.btnFixed){
                document.getElementById('inputPhone').focus();
                return;
            }

            if (!baseMethod.isMobile(_this.phonenum)) {
                _this.showMsg("请输入正确的手机号码");
                return;
            }

            let params = {
                "order_id": _this.orderId,
                "code": _this.captcha
            };

            _this.isDis = true;
            $.ajax({
                url: 'https://api.0168.net.cn/qiaosi/product/code',
                type: 'post',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(params),
                headers: {
                    'Content-Type': 'application/json'
                },
                 success: function(res) {
                    _this.isDis = false;
                    if (res.code.startsWith("5") || res.code.startsWith("4")) {
                        _this.showMsg(res.msg);
                    } else if(res.code.startsWith("6")){
                        _this.showMsg(res.msg);
                        window.parent.location.href = res.returl;
                    } else if (res.code == '00000'){
                        window.parent.location.href = res.returl;
                    }
                },
                error: function(res) {
                    _this.isDis = false;
                    _this.showMsg("系统繁忙，请稍后再试！");
                }
            });
        },
        agreePrivacy(){
            var _this = this;
            _this.checked = true;
            _this.showPrivacy = true;
        },
        showPrivacyBoxOrNot(){
            var _this = this;
            _this.showPrivacy= !_this.showPrivacy;
        },
        iKnow(){
            var _this = this;
            _this.checked = true;
            _this.onFoucs();
        },
        showMsg(msg){
            var _this = this;
            _this.isLoading = true;
            _this.msg = msg;

            setTimeout(function(){
                _this.isLoading = false;
            },1000)
        },
        closeQuitModal(){
            var _this = this;
            _this.showQuitModal = false;
        },
        closeRecomBox(){
            var _this = this;
            _this.showRecomBox = false;
        },
        showActivityOrNot(){
            var _this = this;
            _this.visibleNotes = !_this.visibleNotes;
        },
        onFoucs(){
            document.getElementById('inputPhone').focus();
            return;
        },
        init() {
            var _this = this;
            let params = {
                advert_id: _this.advertId
            }
            $.ajax({
                url: 'https://api.0168.net.cn/qiaosi/order/v3/init',
                type: 'get',
                data: params,
                dataType: "json",
                headers: {
                    'Content-Type': 'application/json'
                },
                success: function(res) {
                    console.log(res.data);
                }
            })
        },
        getPageUrl(){
            var _this = this;
            var param = {
                product: _this.productId,
                channelid: _this.channelid,
                advertId: _this.advertId,
                unionSite: _this.unionSite
            };

            //调试阶段
            if(_this.isDebug == 1 && baseMethod.getQueryString("ip")){
                param['ip'] = baseMethod.getQueryString("ip");
                param['isDebug'] = _this.isDebug;
            }

            if(localStorage.getItem('url') && localStorage.getItem("url_expire") > new Date().getTime()){
                _this.productUrl = localStorage.getItem('url')
            } else {
                $.ajax({
                  url: 'https://api.0168.net.cn/qiaosi/page/v1',
                  type: 'get',
                  data: param,
                  success: function(res){
                      var toUrl = res.data;
                      localStorage.setItem('url', toUrl);
                      localStorage.setItem('url_expire', new Date().getTime() + 30*24*60*60*1000);
                      _this.productUrl = res.data;
                  }
                });
            }
        },
        jumpToActivity(){
            window.location.href = "https://store.0168.net.cn/activity-mall/h5/indexaqy_activity.html";
        }

    }
}
</script>

<style scoped>
    body {
        height: 100%;
    }

    #app {
        padding-top: 0;
        margin: 0;

        width:100%;
        overflow:hidden;
    }

    div {
        margin: 0;
        padding: 0;
    }

    img {
        display: block;
        margin: 0;
        padding: 0;
        border: 0;
    }


    .loading-wrap {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
    }

    .opti_wrap.pd110 {
        padding-bottom: 110px;
    }

    .btn_img.fixed {
        position: fixed;
        bottom: 0;
        z-index: 9
    }

    .loading-box {
        border-radius: 3.2px;
        position: absolute;
        width: 120px;
        left: 50%;
        top: 50%;
        font-size: .560px;
        color: rgb(250, 250, 250);
        text-align: center;
        -webkit-transition: .3s color, .3s border;
        transition: .3s color, .3s border;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.6);
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .opti_wrap {
        background-color: #02c617;
        position: relative;
        min-height: 100vh;
        padding-bottom: 10px;
    }

    .flow_top {
        width: 100%;
        margin: 0 auto;
        position: relative;
    }

    .flow_input_bg{
        margin-top: 1%;
        margin-bottom: -1%;
    }

    .flow_top .lottery_box {
        position: absolute;
        top: 10%;
        left: 5%;
        height: 100px;
        width: 90%;
        overflow: hidden;
    }

    .lottery_box .lotteryBg {
        width: 100%;
        margin: 0 auto;
    }


    .opti_wrap .main-top {
        width: 100%;
    }

    .flow_timer_title {
        width: 90%;
        margin: 15px auto 5px;
        padding: 1% 3%;
        position: absolute;
        bottom: 63%;
        left: 5%;
    }

    .flow_timer_title_content{
        margin-top: 10px;
        font-size: 20px;
        line-height: 18px;
        text-align: center;
        font-weight: 600;
        color: #fff;
    }

    .flow_timer_time {
        width: 90%;
        margin: 15px auto 5px;
        padding: 1% 3%;
        position: absolute;
        bottom: 30%;
        left: 5%;
    }

    .flow_timer_time_hour{
        display:inline-block;
        margin-left: 13.5%;
        font-size: 36px;
        line-height: 18px;
        text-align: center;
        font-weight: 600;
        width: 13.5%;
    }

    .flow_timer_time_minute{
        display:inline-block;
        margin-left: 15.5%;
        font-size: 36px;
        line-height: 18px;
        text-align: center;
        font-weight: 600;
        width: 13.5%;
    }

    .flow_timer_time_second{
        display:inline-block;
        margin-left: 16%;
        font-size: 36px;
        line-height: 18px;
        text-align: center;
        font-weight: 600;
        width: 13.5%;
    }

    .flow_top .flow_select {
        width: 90%;
        margin: 15px auto 5px;
        padding: 1% 3%;
        position: absolute;
        bottom: 10%;
        left: 5%;
    }

    .flow_top .flow_select1 {
        width: 90%;
        margin: 15px auto 5px;
        padding: 1% 3%;
        position: absolute;
        bottom: 5%;
        left: 5%;
    }

    .flow_top .flow_select3 {
        width: 90%;
        margin: 15px auto 5px;
        padding: 1% 3%;
        position: absolute;
        bottom: -3%;
        left: 5%;
    }

    .input_box .phone_txt{
        height: 40px;
        margin:0 2%;
        border-radius: 12px;
        width: 96%;
        border: #ff0000 1px solid;
        background: #fff;
    }

     .formElement1 {
        width: 100%;
        height: auto;
        position: relative;
        font-size: 0;
    }

    .formBox {
        width: 98%;
        height: auto;
        margin: 0 auto;
        border: none !important;
        background: #f1f1f1 !important;
        border-radius: .4rem;
        padding: 0;
        max-width: 640px;
        position: relative;
    }

    .formBox .form {
        width: 90%;
        height: 46px;
        line-height: .8rem;
        margin: .3rem auto 0 auto;
        font-size: .28rem;
        padding-top: 0;
        padding-bottom: 0;
        border: none !important;
        max-width: 640px;
        border-radius: .2rem;
    }

    .phone {
        background: #f1f1f1 !important;
    }

    .van-cell--required {
        overflow: visible;
    }

    .van-cell--required::before {
        position: absolute;
        left: 8px;
        top: 7px;
        color: #ee0a24;
        font-size: 14px;
        content: '*';
    }

    .van-cell {
        position: relative;
        display: flex;
        box-sizing: border-box;
        padding: 10px 16px;
        color: #323233;
    }

    .phone .van-cell__value {
        position: static;
    }

    .van-field__value {
        overflow: visible;
    }

    .van-cell__value--alone {
        color: #323233;
        text-align: left;
    }

    .van-cell__value {
        vertical-align: middle;
        word-wrap: break-word;
    }

    .van-cell__title,
    .van-cell__value {
        -webkit-box-flex: 1;
        flex: 1;
    }

    .van-field__body {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
    }

     input {
        -webkit-writing-mode: horizontal-tb !important;
        text-rendering: auto;
        letter-spacing: normal;
        word-spacing: normal;
        text-transform: none;
        text-indent: 0px;
        text-shadow: none;
        text-align: start;
        appearance: auto;
        -webkit-rtl-ordering: logical;
        cursor: text;
    }

    .van-field__control {
        height: .9rem;
    }

    .van-field__control {
        display: block;
        box-sizing: border-box;
        width: 100%;
        height: 45px;
        min-width: 0;
        margin: 0;
        padding: 0;
        color: #323233;
        line-height: inherit;
        text-align: left;
        background-color: transparent;
        border: 0;
        resize: none;
    }

     .van-field__button {
        position: absolute;
        top: 0;
        right: 0;
    }

    .van-field__button {
        padding-left: 8px;
    }

    .van-field__button,
    .van-field__clear,
    .van-field__icon,
    .van-field__right-icon {
        flex-shrink: 0;
    }


    .product-info{
        margin-top: 10px;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        color: #fff;
    }

    .btn_box {
        margin: 10px auto;
    }

    .btn_box .btn_img {
        width: 90%;
        margin: 0 auto;
        -webkit-animation: mymove .8s infinite;
    }

    .flow_abs_box1 {
        width: 320px;
        margin: 0 auto;
        display: flex;
    }

    .flow_abs_box1 .scroll_box {
        flex: 1;
        width: 300px;
        height: 25px;
        overflow: hidden;
    }



    .scroll_box li {
        align-items: center;
        height: 25px;
        font-size: 12px;
        color: #ff0000;
        text-align: center;
    }

    .swiper-wrapper {
        width: 320px;
        margin: 0 auto;
        display: flex;
    }

    .swiper-wrapper .scroll_box {
        flex: 1;
        width: 300px;
        height: 95px;
        overflow: hidden;
    }


    .swiper-wrapper .scroll_box li {
        align-items: center;
        height: 95px;
        font-size: 12px;
        color: #ff0000;
        text-align: center;
    }


    .ftxs_main {width:100%; margin: 10px auto; position: relative;}


    .vip_benefit_bg{
        margin-top: -40px;
        margin-bottom: -30px;
    }


    .swiper-top {
        position: absolute;
        z-index: 3;
        top: 43%;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .redpack_flow_abs_box1 {
        width: 18%;
        padding: 0;
        margin: 0 5px;
    }

    .redpack_flow_abs_box1 {
        display: flex;
        padding: 2px 5px;
    }

    .redpack_flow_abs_box1 .redpack_scroll_box {
        flex: 1;
        height: 95px;
        overflow: hidden;
    }

    .redpack_flow_abs_box1 .redpack_scroll_box li {
        height: 95px;
    }

    .redpack_scroll_box li {
        align-items: center;
        height: 18px;
        font-size: 12px;
        color: #fff;
    }

    .redpack_flow_abs_box1 img {
        width: 100%;
    }

    .benefit-bg{
        width:100%;
        margin-bottom: 30px;
    }


    .swiper-con {
        position: absolute;
        bottom: 30%;
        left: 10%;
        width: 80%;
    }

    .woread-con{
        position: absolute;
        top: 25%;
        left: 10%;
        width: 80%;
    }

    .woread-con img{
        width: 100%;
        border-radius: 18px;
    }

    .swiper-con .cover {
        width: 100%;
        height: 100%;
    }

    .bottom_txt {position: absolute;bottom: 10%; left: 10%; width: 80%;  text-align: left; color: #000; font-size: 10px; line-height: 18px;}

    .flow_txtBox {
        width: 92%;
        margin: 10px auto 0;
    }

    .flow-title1 {
        width: 100%;
        text-align: center;
        font-size: 18px;
        color: #fff;
        margin: 20px 0 10px;
        letter-spacing: .2em;
    }

    .notes p {
        width: 90%;
        margin: 8px auto;
        color: #000;
        line-height: 20px;
    }

    .notes h5 {
        width: 80%;
        margin: 10px auto;
        line-height: 20px;
    }

    .notes span{
        color: #FF0000;
    }

    .flow_txtBox .txtBg1 {
        width: 100%;
    }

    .flow_txtBox .notes {
        background: #ffc6b4;
        border-radius: 15px;
        box-shadow: 0px 2px 1px 6px rgb(245 35 35 / 60%);
    }

    .bg {
        padding: 15px;
        background: #ffdace;
        border-radius: 15px;
    }

    .flow_txtBox .txtBg2 {
        width: 100%;
        margin-top: -3%;
    }

    .footer{
        width: 60%;
        margin:  20px 20%
    }

    /* .flow_txtBox a{
        color: #fff;
        font-size: 15px;
        line-height: 20px;
    } */

    .flow-title1 {
        display: flex;
        align-items: center;
        opacity: 1;
        margin-bottom: 10px;
        font-weight: 500;
        margin-left: 35%;
    }

    .flow-title1 .icon {
        width: 20px;
    }

    .agree {
        margin: 5px 0 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-weight: 600;
        color: #fff;
    }

    .agree span {
        font-size: 10px;
        color: #fff;
        font-weight: 500;
    }

    .agree span u{
        font-size: 10px;
        color: #f8cf68;
        font-weight: 500;
    }

    .agree img {
        margin-right: 5px;
    }

    .agree span.red {
        color: #000;
        margin: 0 3px;
    }

     .right_txt{
        text-align: left;
        margin-left: 10%;
        margin-top: 40px;
    }

    #cap {
        width: 100%;
        height: 490px;
        position: relative;
        margin: 0px auto;
        background-size: 100% 100%;
    }

    #frame {
        border: 3px solid #fbd2c1;
        border-radius: 30px;
        width: 100%;
        height: 520px;
        transform:  translate(0%,0%);
    }

    a{
        word-wrap: break-word;
    }

    .copyright{
        margin-top: 30px;
        padding-left: 40px;
        padding-right: 40px;
        text-align: left;
        color: #fff;
        font-size: 8px;
    }

    .scroll-container {
        width: 100%;
        height: 0.7rem;
        position: relative;
        margin-top: -1.3rem;
    }

    .scroll-item {
        width: 6rem;
        height: 100%;
        padding: 0 0.2rem;
        position: absolute;
        transition-property: left;
        transition-timing-function: linear;
        background: rgba(0,0,0,.5);
        border-radius: 0.3rem;
        font-size: .3rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
        text-align: center;
        line-height: .7rem;
    }


      @keyframes zy {
        0% {
          transform: rotate(-12deg);
        }
        50% {
          transform: rotate(10deg);
        }
        100% {
          transform: rotate(-12deg);
        }
      }

    .top-activity-rules__d {
        position: absolute;
        top: 0.625rem;
        right: 0;
        background: #ff7446;
        color: white;
        font-size: 14px;
        text-align: center;
        border-radius: 20px 0 0 20px;
        padding: 8px 10px 8px 12px;
        z-index: 9;
    }

    .product-info1 {
        margin-left: 50px;
        margin-right: 50px;
        margin-top: 10px;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
        font-weight: 600;
        color: #000;
    }
</style>



// WEBPACK FOOTER //
// ThemeAqy.vue?b61564d8